module.exports = __webpack_public_path__ + "static/33-9c568e6b2d0f97c9f8edd919820ffdae.jpg";